import { Badge, Hidden, IconButton, MenuItem, Skeleton, TextField, Typography } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import HeadersTab from "./HeadersTab";
import { Link, useNavigate } from "react-router-dom";
import { ChangeEventHandler, useContext } from "react";
import { ProfileContext } from "../../ProfileContext";
import LogoutIcon from '@mui/icons-material/Logout';
import ExpiryBadge from "./ExpiryBadge";

export default function Header() {
	const { profile, setSelectedBranch, selectedBranch } = useContext(ProfileContext);
	const navigate = useNavigate();

	const handleChangeBranch: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
		const id = Number(e.target.value);
		setSelectedBranch(id);
		console.log(id);
		localStorage.setItem('selected_branch', id + '');
	};

	const handleLogout = () => {
		localStorage.removeItem('token');
		localStorage.removeItem('profile');
		navigate('/auth/login');
	};

	return (
		<>
			<div className="bg-primary-main sm:bg-background-paper md:bg-primary-main h-20 flex flex-row items-center w-full px-3 sm:px-4 gap-2 md:mt-6 md:rounded-lg ">
				<img className="h-8 w-8 rounded-full" src='/company.png' alt="company" />
				<div className="flex flex-col min-w-">
					<Typography className="text-primary-contrastText sm:text-text-primary md:text-primary-contrastText text-sm mb-1" >
						{profile?.name ?? <Skeleton className="bg-white" width={100} />}
						<span className="mr-2"><ExpiryBadge profile={profile} /></span>
					</Typography>
					<TextField className="bg-primary-50 rounded" size="small" select value={selectedBranch} onChange={handleChangeBranch}>
						{
							profile?.branch?.map((branch) => (
								<MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="grow h-full pt-4" >
					<Hidden mdDown>
						<HeadersTab heightFull />
					</Hidden>
				</div>


				<Hidden smUp>
					<IconButton component={Link} to="/profile">
						<AccountCircleIcon className="text-primary-contrastText" />
					</IconButton>
				</Hidden>


				<Hidden smDown>
					<IconButton component={Link} to="/profile" title="ویرایش پروفایل">
						<AccountCircleIcon className="text-action-active md:text-primary-contrastText" />
					</IconButton>
					<IconButton component={Link} to="/search/date">
						<SearchIcon className="text-action-active md:text-primary-contrastText" />
					</IconButton>
					<IconButton>
						<Badge badgeContent={1} overlap="circular" color="secondary" anchorOrigin={{ vertical: 'top', horizontal: "left" }} variant="dot">
							<NotificationsIcon className="text-action-active md:text-primary-contrastText" />
						</Badge>
					</IconButton>
					<IconButton component={Link} to="/setting">
						<SettingsIcon className="text-action-active md:text-primary-contrastText" />
					</IconButton>
					<IconButton onClick={handleLogout}>
						<LogoutIcon className="text-action-active md:text-primary-contrastText" />
					</IconButton>
				</Hidden>
			</div>
			<Hidden smDown mdUp>
				<HeadersTab />
			</Hidden>
		</>
	);
}